module.exports = __webpack_public_path__ + "img/fire-flame-08.589b35dc.png";